// extracted by mini-css-extract-plugin
export default {"adminLayout":"index_adminLayout__Gy8qA"};